__turbopack_context__.v({
  "ra-footer-newsletter": "LsAoOq_ra-footer-newsletter",
  "ra-footer-newsletter__form": "LsAoOq_ra-footer-newsletter__form",
  "ra-footer-newsletter__wrapper": "LsAoOq_ra-footer-newsletter__wrapper",
});
